export const EVENT_FOREX_CURRENCY_LIMITS_CHANGE = 'forexCurrencyLimits.change'
